import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import AboutUs from "./Components/Setting/AboutUs";
import AttandanceIndex from "./Components/Attandance/AttandanceIndex";
import AttandanceEdit from "./Components/Attandance/AttandanceEdit";
import AttandanceView from "./Components/Attandance/AttandanceEdit";
import CategoryIndex from "./Components/Category/CategoryIndex";
import CategoryEdit from "./Components/Category/CategoryEdit";
import CategoryNew from "./Components/Category/CategoryNew";
import CategoryView from "./Components/Category/CategoryView";

import BlindTestIndex from "./Components/BlindTest/BlindTestIndex";
import BlindTestEdit from "./Components/BlindTest/BlindTestEdit";
// import BlindTestNew from "./Components/BlindTest/BlindTestNew";
// import BlindTestView from "./Components/BlindTest/BlindTestView";

import ClassIndex from "./Components/Class/ClassIndex";
import ClassEdit from "./Components/Class/ClassEdit";
import ClassNew from "./Components/Class/ClassEdit";
// import FolderView from "./Components/Folder/FolderView";

import FolderIndex from "./Components/Folder/FolderIndex";
import FolderEdit from "./Components/Folder/FolderEdit";
import FolderNew from "./Components/Folder/FolderEdit";
import FolderView from "./Components/Folder/FolderView";

import Container from "./Container";
import Dashboard from "./Components/Dashboard";
import Login from "./Components/Login";
import Register from "./Components/Register";
import TermAndCondition from "./Components/Setting/TermAndCondition";
import UserIndex from "./Components/User/UserIndex";
import UserNew from "./Components/User/UserNew";
import UserEdit from "./Components/User/UserEdit";
import UserView from "./Components/User/UserView";
import Questionsindex from "./Components/Questions/QuestionsIndex";
import QuestionsNew from "./Components/Questions/QuestionsNew";
import QuestionsEdit from "./Components/Questions/QuestionsEdit";
import QuestionsView from "./Components/Questions/QuestionsView";

import "./index.css";
import NewsNew from "./Components/News/NewsNew";
import NewsEdit from "./Components/News/NewsEdit";
import NewsView from "./Components/News/NewsView";
import NewsIndex from "./Components/News/NewsIndex";
import Error404 from "./Components/Error404";
import BuildUpdate from "./Components/BuildUpdate";

// Report
import SellReport from "./Components/Report/SellReport";
import SubscriptionReport from "./Components/Report/SubscriptionReport";
import UserReport from "./Components/Report/UserReport";
import VideoReport from "./Components/Report/VideoReport";

//User Management
import Role from "./Components/UserManagement/role";
import Permission from "./Components/UserManagement/permission";

// Branch
import BranchIndex from "./Components/Branch/BranchIndex";
import BranchEdit from "./Components/Branch/BranchEdit";

// Group Permission
import GroupPermissionIndex from "./Components/GroupPermission/GroupPermissionIndex";
import GroupPermissionEdit from "./Components/GroupPermission/GroupPermissionEdit";

// Word List
import WordListIndex from "./Components/WordList/WordListIndex";
import WordListEdit from "./Components/WordList/WordListEdit";

// user test result
import UserTestResultIndex from "./Components/UserTestResult/UserTestResultIndex.js";
import UserTestResultView from "./Components/UserTestResult/UserTestResultView.js";


// Word Type
import WordTypeIndex from "./Components/WordType/WordTypeIndex";
import WordTypeEdit from "./Components/WordType/WordTypeEdit";
import Privacy from "./Components/Setting/Privacy";
import { ReasonEdit } from "./Components/Reason/ReasonEdit";
import ReasonIndex from "./Components/Reason/ReasonIndex";
import DailyTaskEdit from "./Components/DailyTask/DailyTaskEdit";
import DailyTaskIndex from "./Components/DailyTask/DailyTaskIndex";
import { TopicIndex } from "./Components/Topic/TopicIndex";
import { TopicEdit } from "./Components/Topic/TopicEdit";
import { TopicView } from "./Components/Topic/TopicView";
import { WordTypeView } from "./Components/WordType/WordTypeView.js";
import ClassView from "./Components/Class/ClassView.js";


const router = createBrowserRouter([
  {
    path: "/login",
        element: <Login />
  },
  {
    path: "/register",
        element: <Register />
  },
  {
    path: "*",
        element: <Error404 />
  },
  {
    path: "/build_update",
        element: <BuildUpdate />
  },
  {
    path: "/",
    element: <Container/>,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "userindex",
        element: <UserIndex />,
      },
      {
        path: "usernew",
        element: <UserEdit />,
      },
      {
        path: "usertestresultindex",
        element: <UserTestResultIndex />,
      },
      {
        path: "usertestresultview",
        element: <UserTestResultView />,
      },
      {
        path: "useredit",
        element: <UserEdit />,
      },
      {
        path: "userview",
        element: <UserView />,
      },

      {
        path: "attandanceindex",
        element: <AttandanceIndex />,
      },
      {
        path: "attandancenew",
        element: <AttandanceEdit />,
      },
      {
        path: "attandanceedit",
        element: <AttandanceEdit />,
      },
      {
        path: "attandanceview",
        element: <AttandanceEdit />,
      },

      {
        path: "dailytaskindex",
        element: <DailyTaskIndex />,
      },
      {
        path: "dailytaskedit",
        element: <DailyTaskEdit />,
      },
      {
        path: "topicindex",
        element: <TopicIndex />,
      },
      ,
      {
        path: "topicview",
        element: <TopicView />,
      },
      {
        path: "topicedit",
        element: <TopicEdit />,
      },

      {
        path: "questionindex",
        element: <Questionsindex />,
      },
      {
        path: "questionedit",
        element: <QuestionsEdit />, 
      },
      {
        path: "questionview",
        element: <QuestionsView />,
      },
      {
        path: "questionnew",
        element: <QuestionsNew />,
      },
      {
        path: "categoryindex",
        element: <CategoryIndex />,
      },
      {
        path: "categorynew",
        element: <CategoryNew />,
      },
      {
        path: "categoryedit",
        element: <CategoryEdit />,
      },
      {
        path: "categoryview",
        element: <CategoryView />,
      },
      {
        path: "blindtestindex",
        element: <BlindTestIndex />,
      },
      {
        path: "blindtestnew",
        element: <BlindTestEdit />,
      },
      {
        path: "blindtestedit",
        element: <BlindTestEdit />,
      },
      {
        path: "blindtestview",
        element: <BlindTestEdit />,
      },
      {
        path: "classindex",
        element: <ClassIndex />,
      },
      {
        path: "classnew",
        element: <ClassNew />,
      },
      {
        path: "classedit",
        element: <ClassEdit />,
      },
      {
        path: "classview",
        element: <ClassView />,
      },
      {
        path: "folderindex",
        element: <FolderIndex />,
      },
      {
        path: "foldernew",
        element: <FolderNew />,
      },
      {
        path: "folderedit",
        element: <FolderEdit />,
      },
      {
        path: "folderview",
        element: <FolderView />,
      },
      {
        path: "newsindex",
        element: <NewsIndex />,
      },
      {
        path: "newsnew",
        element: <NewsNew />,
      },
      {
        path: "newsedit",
        element: <NewsEdit />,
      },
      {
        path: "newsview",
        element: <NewsView />,
      },
      {
        path: "/usersreport",
        element: <UserReport />,
      },
      {
        path: "/videosreport",
        element: <VideoReport />,
      },
      {
        path: "/subscriptionreport",
        element: <SubscriptionReport />,
      },
      {
        path: "/sellreport",
        element: <SellReport />,
      },
      {
        path: "/role",
        element: <Role />,
      },
      {
        path: "/permission",
        element: <Permission />,
      },
      {
        path: "/aboutus",
        element: <AboutUs />,
      },
      {
        path: "/termandcondition",
        element: <TermAndCondition />,
      },
      {
        path: "/privacy",
        element: <Privacy />,
      },
      // branch
      {
        path: "branchindex",
        element: <BranchIndex />,
      },
      {
        path: "branchnew",
        element: <BranchEdit />,
      },
      {
        path: "branchedit",
        element: <BranchEdit />,
      },
      {
        path: "branchview",
        element: <BranchEdit />,
      },
      // group permission
      {
        path: "grouppermissionindex",
        element: <GroupPermissionIndex />,
      },
      {
        path: "grouppermissionnew",
        element: <GroupPermissionEdit />,
      },
      {
        path: "grouppermissionedit",
        element: <GroupPermissionEdit />,
      },
      {
        path: "grouppermissionview",
        element: <GroupPermissionEdit />,
      },
      // word list
      {
        path: "wordlistindex",
        element: <WordListIndex />,
      },
      {
        path: "wordlistnew",
        element: <WordListEdit />,
      },
      {
        path: "wordlistedit",
        element: <WordListEdit />,
      },
      {
        path: "wordlistview",
        element: <WordListEdit />,
      },
      // word type
      {
        path: "wordtypeindex",
        element: <WordTypeIndex />,
      },
      {
        path: "wordtypenew",
        element: <WordTypeEdit />,
      },
      {
        path: "wordtypeedit",
        element: <WordTypeEdit />,
      },
      {
        path: "wordtypeview",
        element: <WordTypeView />,
      },
      // reason
      {
        path: "reasonindex",
        element: <ReasonIndex />,
      },
      {
        path: "reasonnew",
        element: <ReasonEdit />,
      },
      {
        path: "reasonedit",
        element: <ReasonEdit />,
      },
      {
        path: "reasonview",
        element: <ReasonEdit />,
      },
    ]
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  // <BrowserRouter>
  //   <App />
  // </BrowserRouter>,

  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);